import React, {
  useContext,
} from 'react';
import {
  ErrorMessage,
} from 'formik';
import {
  ThemeContext,
} from 'styled-components';

import {
  Select,
} from 'web-components';
import {
  Flex,
} from 'web-styled';
import { CSSObjectWithLabel } from 'react-select';

import * as S from './styled';

type OptionType = {
  label: string;
  value: string;
};

export type Props = {
  flex: string;
  width?: string;
  spacing?: number;
  field: any;
  label?: string;
  form: any;
  type?: string;
  color?: string;
  labelWeight?: string;
  styles: any;
  theme: any;
  options?: OptionType[];
  placeholder?: string;
  onChange: { (option: OptionType, oldValue?: OptionType): void };
};

const SelectField = ({
  type = 'text',
  label,
  form,
  field,
  placeholder,
  flex,
  width = '100%',
  spacing = 10,
  color,
  labelWeight,
  options = [],
  styles,
  theme,
  onChange,
  ...props
}: Props) => {
  const baseTheme = useContext(ThemeContext);
  const iserror = (form.touched[field.name] && form.errors[field.name]);
  let value = options?.find(option => option.value === field.value);

  // It looks like this is a select bug, after updating if the new value is empty,
  // the select shows the old value
  if (!value && field.value) {
    value = {
      value: field.value,
      label: field.value,
    };
  } else if (field.value === '') {
    value = null;
  }

  return (
    <Flex
      column
      width={width}
      spacing={spacing}
      flex={flex}
    >
      {label && (
        <S.Label
          htmlFor={`${field.name}-id`}
          color={color}
          weight={labelWeight}
        >
          {label}
        </S.Label>
      )}
      <S.SelectContainer>
        <Select
          {...field}
          {...props}
          id={`${field.name}-id`}
          value={value}
          theme={theme}
          styles={{
            ...styles,
            control: (base: CSSObjectWithLabel) => ({
              ...base,
              height: 'calc(2.25rem + 9px)',
              minHeight: '34px',
              boxShadow: 'none',
              borderWidth: '1px',
              borderColor: iserror ? baseTheme?.colors.danger : '#ddd',
              '&:focus': {
                borderColor: iserror ? baseTheme?.colors.danger : '#ddd',
              },
              '&:hover': {
                borderColor: iserror ? baseTheme?.colors.danger : '#ddd',
              },

              ...(styles?.control
                ? styles.control(base)
                : {}
              ),
            }),
            placeholder: (base: CSSObjectWithLabel) => ({
              ...base,
              color: '#c1c1c1',
            })
          }}
          options={options}
          placeholder={placeholder}
          onChange={(option: OptionType) => {
            form.setFieldValue(field.name, option?.value);
            if (onChange) {
              onChange(option, value);
            }
          }}
        />
      </S.SelectContainer>
      <ErrorMessage
        name={field.name}
        component={S.Error}
      />
    </Flex>
  );
};

export default SelectField;
